import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Col, Row, Container, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { SVG } from '@svgdotjs/svg.js'
import { BookList } from '../../enums'
import * as tooltips from '../../strings'
import book_1 from './book.pdf'
import data_1 from '../../Assets/syncData.json'
import { Document, Page, pdfjs } from 'react-pdf';
import SnapModal from './SnapModal';
import { compareProp } from '../../Utils';
import FullScreenModal from './FullScreenModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
pdfjs.GlobalWorkerOptions.workerSrc = `./pdf.worker.js`;

const WAIT_INTERVAL = 2500;
const SNAP_SIZE = {
    width: 640,
    height: 360
};

const Main = props => {
    const {
        selectedBook,
        toggleHelp,
        homeTooltip,
        handleHomeTooltip
    } = props
    const [videoList, setVideoList] = useState(null)
    const [subsList, setSubList] = useState(null)
    const [mySvg, setMySvg] = useState(null)
    const [numPages, setNumPages] = useState(null)
    const [pageNumber, setPageNumber] = useState(1)
    const [controlPageNumber, setControlPageNumber] = useState(1)
    const [syncData, setSyncData] = useState(null)
    //const [lastSelectedRectIds, setLastSelectedRectIds] = useState([])
    const [currentVolume, setCurrentVolume] = useState(1)
    const [enableSubtitles, setEnableSubtitles] = useState(false)
    const [snapShots, setSnapshots] = useState([])
    const [isSnapModalOpen, setIsSnapModalOpen] = useState(false)
    const [currentSnapId, setCurrentSnapId] = useState(null)
    //const [snapComments, setSnapComments] = useState([])
    const [autoPlay, setAutoPlay] = useState(false)
    //Playlist includes video name and mark data
    const [currentPlaylist, setCurrentPlaylist] = useState([])
    const [currentTrack, setCurrentTrack] = useState(0)
    const [mySelectedVideo, setMySelectedVideo] = useState({
        media: null,
        label: null,
        currentRate: '1.0',
        subtitle: null,
    })
    const [resize, setResize] = useState(false)

    const [disableAutoPlay, setDisableAutoPlay] = useState(true)
    const [showFullScreenPdf, setShowFullScreenPdf] = useState(false)
    const [helpIsActive, setHelpIsActive] = useState(false)
    const [mute, setMute] = useState(false)

    const docRef = useRef(null)
    const videoRef = useRef(null)
    const myControlsRef = useRef(null)
    const controlsTimeout = useRef(null)
    const videoContext = useRef(null)
    const subtitlessContext = useRef(null)
    const tooltipsContext = useRef(null)

    useEffect(() => {
        const handleResize = () => {
            const mainStyles = document.getElementById('pdf-window').style;
            const height = window.innerHeight
            const ratio_h = height / 975;
            let scale = ratio_h;
            if (scale > 1 || height > 860) {
                scale = 1;
                setResize(false);
                mainStyles.setProperty('transform', "scale(" + scale + ")");
            } else {
                setResize(true);
                mainStyles.setProperty('transform', "scale(" + scale + ")");
            }
        }

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        let tooltips = null
        tooltips = require.context(`../../Assets/tooltips`, false, /.*\.mp4$/)
        tooltipsContext.current = tooltips
    }, [])

    const handleTooltips = (param) => {
        const subKey = tooltipsContext.current.keys().filter(x => x.includes(param))
        if (subKey) {
            setMySelectedVideo({
                media: tooltipsContext.current(subKey[0]),
                label: subKey[0],
                currentRate: '1.0',
                subtitle: null,
            })
        }
    }

    useEffect(() => {
        if (helpIsActive && homeTooltip) handleTooltips('002')
    }, [homeTooltip, helpIsActive])

    useEffect(() => {
        setHelpIsActive(toggleHelp)
        if (!toggleHelp) {
            setMySelectedVideo({
                media: null,
                label: null,
                currentRate: '1.0',
                subtitle: null,
            })
            handleHomeTooltip(false)
        }
    }, [toggleHelp, handleHomeTooltip])

    useEffect(() => {
        let vidContext = null
        switch (selectedBook) {
            case BookList.book_1:
                vidContext = require.context(`../../Assets/videos`, false, /.*\.mp4$/)
                break;
            default:
                break;
        }

        const vidList = vidContext && vidContext.keys().map(x => {
            return {
                label: x.replace('./', '').replace('.mp4', ''),
                key: x
            }
        })

        videoContext.current = vidContext
        setVideoList(vidList);
        let subsContext = null

        switch (selectedBook) {
            case BookList.book_1:
                subsContext = require.context('../../Assets/subs', false, /.*\.vtt$/)
                break;
            default:
                break;
        }

        const subtitlesList = subsContext && subsContext.keys().map(x => {

            return {
                label: x.replace('./', '').replace('.vtt', ''),
                key: x
            }
        })

        subtitlessContext.current = subsContext
        setSubList(subtitlesList)
        //console.log(subsContext.keys())
    }, [selectedBook])

    useEffect(() => {
        if (!syncData) return
        const temp = syncData.find(x => x.pageNumber === pageNumber)
        if (!temp) return
        let pageVideos = []
        temp.marks.forEach(mark => {
            if (pageVideos.findIndex(v => v.videoFile === mark.videoFile) === -1) {
                //console.log(mark)
                pageVideos = [...pageVideos, { ...mark }]
            }
        })
        setCurrentPlaylist(pageVideos.sort((a, b) => compareProp(a, b, "videoFile")))
        setDisableAutoPlay(pageVideos.length > 0 ? false : true)
    }, [pageNumber, syncData])

    const handleRectClick = useCallback((e) => {
        if (!mySvg || isSnapModalOpen || helpIsActive) return
        let data = []
        switch (selectedBook) {
            case BookList.book_1:
                data = data_1
                break;
            default:
                break;
        }
        let videoFile = null
        mySvg.children().forEach(x => {
            if (x.attr('id') === e.target.id) {
                //x.classList.remove('hidden')
                data.find(x => x.pageNumber === pageNumber).marks
                    .forEach(m => {
                        if (m.id === e.target.id) {
                            videoFile = m.videoFile
                            //console.log('video1', videoFile)
                        }
                    })
                let selectedVideo = null
                const found = videoList.find(x => x.label === videoFile)
                if (found) {
                    selectedVideo = videoContext.current(found.key)
                    //console.log('selectedVideo', selectedVideo)
                }

                let subKey = null
                let subtitle = null
                if (selectedVideo) {
                    subKey = subtitlessContext.current.keys().filter(x => x.includes(videoFile))
                    //console.log('subKey', subKey)
                    subtitle = subtitlessContext.current(subKey[0])
                    //console.log('subtitle', subtitle)
                }
                //TODO: merge with above
                data.find(x => x.pageNumber === pageNumber).marks
                    .forEach(m => {
                        const myElement = document.getElementById(`${m.id}`)
                        //console.log('myElement', myElement)
                        if (myElement && m.videoFile === videoFile) {
                            myElement.classList.remove('hidden')
                        } else {
                            if (myElement && !myElement.classList.contains('hidden')) {
                                myElement.classList.add('hidden')
                            }
                        }
                    })
                setMySelectedVideo({
                    media: selectedVideo,
                    label: videoFile,
                    currentRate: '1.0',
                    isMuted: mute,
                    subtitle
                })
                //document.getElementById('toggle-play').setAttribute('data-state', 'play')

            }
        });

    }, [selectedBook, videoList, pageNumber, mySvg, isSnapModalOpen, helpIsActive, mute])

    useEffect(() => {
        if (isSnapModalOpen) {
            document.removeEventListener('click', handleRectClick);
        } else document.addEventListener('click', handleRectClick);
        return () => {
            document.removeEventListener('click', handleRectClick);
        }
    }, [handleRectClick, isSnapModalOpen])

    const handleChangePage = num => event => {
        if (helpIsActive) return
        if (autoPlay) {
            setAutoPlay(false)
            setCurrentTrack(0)
        }
        setPageNumber(prevPageNumber => (prevPageNumber + num))
    }

    const handleToggleAutoPlay = () => {
        if (currentPlaylist.length === 0 || helpIsActive) return
        if (!autoPlay) {
            setAutoPlay(true)
            const id = currentPlaylist[0].id
            setCurrentTrack(0)
            handleRectClick({
                target: {
                    id: id
                }
            })
        } else {
            playPauseCurrentVideo();
            setAutoPlay(false);
            setMySelectedVideo({
                media: null,
                label: null,
                currentRate: '1.0',
                subtitle: null,
                isMuted: mute
            })
        }
    }

    const handleToggleDocFullScreen = () => {
        if (helpIsActive) return
        setShowFullScreenPdf(prevState => (!prevState))
    }

    const handleLoadSuccess = (doc) => {
        const { numPages } = doc
        setNumPages(numPages);
        setPageNumber(1);
    }

    const initialize = useCallback(() => {
        setControlPageNumber(pageNumber)
        let data = []
        switch (selectedBook) {
            case BookList.book_1:
                data = data_1
                break;
            default:
                break;
        }
        if (!data) return
        const tempSvg = data.find(x => x.pageNumber === pageNumber)
        //console.log('Found sync data for current page', tempSvg)
        if (tempSvg.svgObject) {
            setMySvg(SVG(`${tempSvg.svgObject}`).addTo('div.react-pdf__Page__svg'))
        }

        setSyncData(data)
        //console.log('temp:', tempSvg)
    }, [selectedBook, pageNumber])


    //Player controls
    const autoHideControls = () => {
        const myElement = myControlsRef.current
        if (myElement.classList.contains('auto-hide')) {
            myElement.classList.remove('auto-hide')
        }
        clearTimeout(controlsTimeout.current)
        controlsTimeout.current =
            setTimeout(() => {
                myElement.classList.add('auto-hide')
            }, WAIT_INTERVAL);
    }

    const handleProgress = () => {
        const percent = (videoRef.current.currentTime / videoRef.current.duration) * 100;
        const myProgressBar = document.getElementById('progress-filled-bar')
        myProgressBar.style.flexBasis = `${percent}%`;
    }

    const toggleFullScreen = () => {
        if (!mySelectedVideo.media || helpIsActive) return
        const myPlayer = document.getElementsByClassName('my-video-player-box')[0]

        const isInFullScreen = (document.fullscreenElement && document.fullscreenElement !== null) ||
            (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
            (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
            (document.msFullscreenElement && document.msFullscreenElement !== null)

        if (!isInFullScreen) {
            if (myPlayer.requestFullscreen) {
                myPlayer.requestFullscreen();
            } else if (myPlayer.mozRequestFullScreen) {
                myPlayer.mozRequestFullScreen(); // Firefox
            } else if (myPlayer.webkitRequestFullscreen) {
                myPlayer.webkitRequestFullscreen(); // Chrome and Safari
            } else if (myPlayer.msRequestFullscreen) {
                myPlayer.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
    }

    const seekTime = e => {
        if (!mySelectedVideo.media) return
        const rect = e.target.getBoundingClientRect()
        const x = Math.round(e.clientX - rect.left) //x position within the element.

        const myProgress = document.getElementById('progress-bar')
        const seekTime = (x / myProgress.offsetWidth) * videoRef.current.duration;

        videoRef.current.currentTime = seekTime
    }

    const handlePlaybackSpeed = (offset) => event => {
        if (helpIsActive) return
        let targetRate = (videoRef.current.playbackRate + offset).toFixed(1)
        if ((targetRate >= 0.1) && (targetRate <= 2)) {
            videoRef.current.playbackRate = targetRate
            setMySelectedVideo(prevState => ({
                ...prevState,
                currentRate: `${targetRate}`
            }))
        }
    }

    useEffect(() => {
        if (!mySelectedVideo.media) return
        if (mute) { videoRef.current.muted = true } else { videoRef.current.muted = false }
    }, [mySelectedVideo.media, mute])

    const playPauseCurrentVideo = useCallback(() => {
        if (!mySelectedVideo.media) return
        if (videoRef.current.paused) {
            videoRef.current.play()
            document.getElementById('toggle-play').setAttribute('data-state', 'pause')
        } else {
            videoRef.current.pause()
            document.getElementById('toggle-play').setAttribute('data-state', 'play')
        }
    }, [mySelectedVideo.media])

    useEffect(() => {
        if (!mySelectedVideo.media) return
        playPauseCurrentVideo()
    }, [mySelectedVideo.media, playPauseCurrentVideo])

    const handleVideoEnded = () => {
        if (!autoPlay) {
            document.getElementById('toggle-play').setAttribute('data-state', 'play')
        } else {
            const track = currentTrack + 1
            if (track < currentPlaylist.length) {
                const id = currentPlaylist[track].id
                setCurrentTrack(track)
                handleRectClick({
                    target: {
                        id: id
                    }
                })
            } else {
                document.getElementById('toggle-play').setAttribute('data-state', 'play')
                setAutoPlay(false)
                setCurrentTrack(0)
            }
        }
    }

    const takeSnap = () => {
        //const snapShots = [...snapShots]
        const index = snapShots.length
        if (index >= 8 || helpIsActive) return
        const id = `my-canvas-${index + 1}`
        const video = document.getElementById('my-video')

        const canvas = document.createElement('canvas')
        const mySnapContainer = document.getElementsByClassName('snap-container')[0]
        const snapBox = document.createElement('div')
        snapBox.setAttribute('id', `my-snap-${index + 1}`)
        snapBox.setAttribute('class', "canvas-box")
        snapBox.appendChild(canvas)
        mySnapContainer.appendChild(snapBox)

        const context = canvas.getContext('2d')

        canvas.setAttribute('id', id)
        canvas.setAttribute('class', "canvas-capture")
        canvas.width = SNAP_SIZE.width;
        canvas.height = SNAP_SIZE.height;

        context.fillRect(0, 0, SNAP_SIZE.width, SNAP_SIZE.height);
        context.drawImage(video, 0, 0, SNAP_SIZE.width, SNAP_SIZE.height);

        //const canvas2 = canvas.cloneNode(true)
        const video2 = document.importNode(video, true);
        video2.setAttribute('id', 'temp')
        // snapShots.push({
        //     snap: canvas,
        //     id: id,
        //     comment: ''
        // })

        setSnapshots(prevSnaps => (
            [...prevSnaps,
            {
                snap: canvas,
                id: id,
                comment: ''
            }]))
    }

    const toggleSubtitles = () => {
        if (helpIsActive) return
        setEnableSubtitles(prevState => (!prevState))
    }

    const toggleVolume = () => {
        if (!mySelectedVideo.media || helpIsActive) return
        if (videoRef.current.muted || mute) {
            setMute(false)
            document.getElementById('mute').setAttribute('data-state', 'mute')
        } else {
            setMute(true)
            document.getElementById('mute').setAttribute('data-state', 'unmute')
        }
    }

    const changeVolume = (e) => {
        const vol = e.target.value
        videoRef.current.volume = vol
        setCurrentVolume(vol)
    }

    const editSnap = (e) => {
        const id = e.target.id
        if (!id || !id.includes('my-canvas-')) return
        setCurrentSnapId(id);
    }

    useEffect(() => {
        //togglesnapmodal
        if (!currentSnapId) return
        setIsSnapModalOpen(prevState => (!prevState));
    }, [currentSnapId])

    useEffect(() => {
        if (!isSnapModalOpen || !currentSnapId) return
        // const img = new Image();
        // img.id = "theDuplicate";
        // img.src = this.state.snapShots[0];
        // const canvasEditBox = document.getElementById('canvas-edit-box')
        // canvasEditBox.appendChild(this.state.snapShots[0])
        // return
        const oldCanvas = document.getElementById(`${currentSnapId}`)

        const newCanvas = document.createElement('canvas');
        const context = newCanvas.getContext('2d');

        newCanvas.width = SNAP_SIZE.width;
        newCanvas.height = SNAP_SIZE.height;

        context.fillRect(0, 0, SNAP_SIZE.width, SNAP_SIZE.height);
        context.drawImage(oldCanvas, 0, 0, SNAP_SIZE.width, SNAP_SIZE.height);

        const canvasEditBox = document.getElementById('canvas-edit-box')
        canvasEditBox.appendChild(newCanvas)
    }, [isSnapModalOpen, currentSnapId])

    const handleClose = () => {
        const printArea = document.getElementById('print-area')
        if (printArea.firstChild) printArea.firstChild.remove()
        setIsSnapModalOpen(false);
        setCurrentSnapId(null);
    }

    const saveSnapData = useCallback((id, comment) => {
        setSnapshots(prevSnaps => ([
            ...prevSnaps.map(x => {
                return x.id === id ? { ...x, comment: comment } : x
            })])
        );
        setIsSnapModalOpen(false);
        setCurrentSnapId(null);
    }, [])

    const printSnap = useCallback((id, comment) => {
        const oldCanvas = document.getElementById(id)
        const newCanvas = document.createElement('canvas');
        const context = newCanvas.getContext('2d');

        newCanvas.width = SNAP_SIZE.width;
        newCanvas.height = SNAP_SIZE.height;

        context.fillRect(0, 0, SNAP_SIZE.width, SNAP_SIZE.height);
        context.drawImage(oldCanvas, 0, 0, SNAP_SIZE.width, SNAP_SIZE.height);
        const printDoc = document.createElement('div')
        printDoc.setAttribute('class', 'printable')
        const img = new Image()
        img.class = 'print-img printable'
        const text = document.createElement('div')
        text.setAttribute('class', 'print-text printable')
        text.innerHTML = comment
        img.src = newCanvas.toDataURL('image/png', 1.0);
        printDoc.appendChild(img)
        printDoc.appendChild(text)
        const printArea = document.getElementById('print-area')
        if (printArea.firstChild) printArea.firstChild.remove()
        printArea.appendChild(printDoc)

        setTimeout(() => {
            window.print();
        }, 350);

    }, [])

    const deleteSnap = useCallback((id) => {
        document.getElementById(id).parentNode.remove()
        setSnapshots(prevSnaps => {
            return prevSnaps.filter(x => x.id !== id)
        })
        setIsSnapModalOpen(false);
        setCurrentSnapId(null);
    }, [])

    const deleteAllSnaps = () => {
        snapShots.forEach(x => {
            document.getElementById(x.id).parentNode.remove()
        })

        setSnapshots([])

        setCurrentSnapId(null);
    }

    const handleGoToPage = (input) => {
        const page = parseInt(input)
        if (page > 0 && page <= numPages) {
            setPageNumber(page)
        }
    }

    return (
        <Container fluid className="main-app" >
            <Row>
                <Col md={6} id={"pdf-window"} style={{ padding: resize ? 0 : '25px', position: !resize ? 'inherit' : 'absolute', top: '0' }} ref={docRef}>
                    <Row>
                        <Col xs={'auto'}>
                            <div className="pdf-controls">
                                <OverlayTrigger
                                    trigger="focus"
                                    placement={'bottom'}
                                    overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.START_PAGE}</Tooltip>}>
                                    <Button
                                        onClick={() => helpIsActive ? handleTooltips('015') : setPageNumber(1)}
                                        variant="warning"
                                        disabled={pageNumber === 1 && !helpIsActive}
                                        className="pdf-control-button first-page" />
                                </OverlayTrigger>
                                <OverlayTrigger
                                    trigger="focus"
                                    placement={'bottom'}
                                    overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.PREV_PAGE}</Tooltip>}>
                                    <Button
                                        onClick={() => helpIsActive ? handleTooltips('016') : handleChangePage(-1)()}
                                        variant="warning"
                                        disabled={pageNumber <= 1 && !helpIsActive}
                                        className="pdf-control-button previous-page" />
                                </OverlayTrigger>
                                <OverlayTrigger
                                    trigger="focus"
                                    placement={'bottom'}
                                    overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.NEXT_PAGE}</Tooltip>}>
                                    <Button
                                        disabled={pageNumber >= numPages && !helpIsActive}
                                        onClick={() => helpIsActive ? handleTooltips('017') : handleChangePage(1)()}
                                        variant="warning"
                                        className="pdf-control-button next-page"
                                    />
                                </OverlayTrigger>
                                <OverlayTrigger
                                    trigger="focus"
                                    placement={'bottom'}
                                    overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.END_PAGE}</Tooltip>}>
                                    <Button
                                        disabled={pageNumber === numPages && !helpIsActive}
                                        onClick={() => helpIsActive ? handleTooltips('018') : setPageNumber(numPages)}
                                        variant="warning"
                                        className="pdf-control-button last-page"
                                    />
                                </OverlayTrigger>
                                <input
                                    className="current-page"
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) => setControlPageNumber(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && handleGoToPage(controlPageNumber)}
                                    type="text"
                                    value={controlPageNumber} />
                                <input className="total-pages" disabled type="text" value={numPages ? `/ ${numPages}` : '-'} />
                                <OverlayTrigger
                                    trigger="focus"
                                    placement={'bottom'}
                                    overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.AUTO_PLAY}</Tooltip>}>
                                    <Button
                                        id="autoplay-btn"
                                        disabled={(disableAutoPlay || pageNumber >= numPages) && !helpIsActive}
                                        onClick={() => helpIsActive ? handleTooltips('020') : handleToggleAutoPlay()}
                                        variant="warning"
                                        className={autoPlay ? "pdf-control-button pause" : "pdf-control-button play"}
                                    />
                                </OverlayTrigger>
                                <OverlayTrigger
                                    trigger="focus"
                                    placement={'bottom'}
                                    overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.FULL_SCRN}</Tooltip>}>
                                    <Button
                                        onClick={() => helpIsActive ? handleTooltips('019') : handleToggleDocFullScreen()}
                                        variant="warning"
                                        className="pdf-control-button fullscreen-page"
                                    />
                                </OverlayTrigger>
                            </div>
                            <div className="pdf-document">
                                <Document
                                    file={book_1}
                                    onLoadSuccess={handleLoadSuccess}
                                    className='no-select'
                                >
                                    <Page
                                        //width={400}
                                        // renderTextLayer={false}
                                        renderInteractiveForms={false}
                                        className='my-page'
                                        pageNumber={pageNumber}
                                        //inputRef={(ref) => { docRef.current = ref; console.log(ref) }}
                                        onRenderSuccess={initialize}
                                        renderMode={'svg'}
                                    />
                                </Document>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col md={6} style={{ padding: '25px', position: !resize ? 'inherit' : 'absolute', right: '0' }}>
                    <Row>
                        <Col>
                            <div onMouseMove={autoHideControls} className="my-video-player-box">
                                <video
                                    onEnded={handleVideoEnded}
                                    onTimeUpdate={handleProgress}
                                    onDoubleClick={toggleFullScreen}
                                    key={mySelectedVideo.label}
                                    id="my-video"
                                    className='my-video-player'
                                    ref={videoRef}>
                                    <source src={mySelectedVideo.media} type="video/mp4" />
                                    {enableSubtitles && mySelectedVideo.subtitle &&
                                        <track label="Greek" kind="subtitles" srcLang="el" src={mySelectedVideo.subtitle} default />}
                                    <p>Your browser doesn't support HTML5 video.</p>
                                </video>

                                <div className="my-controls" ref={myControlsRef}>
                                    <div onClick={seekTime} id="progress-bar" className="progress">
                                        <div id="progress-filled-bar" className="progress-filled"></div>
                                    </div>
                                    <OverlayTrigger
                                        trigger="focus"
                                        placement={'bottom'}
                                        overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.VIDEO_DECREASE_PLAYBACK}</Tooltip>}>
                                        <Button
                                            id="delay-playback"
                                            onClick={() => helpIsActive ? handleTooltips('010') : handlePlaybackSpeed(-0.1)()}
                                            variant="warning"
                                            className="player-button" />
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        trigger="focus"
                                        placement={'bottom'}
                                        overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.VIDEO_PLAY}</Tooltip>}>
                                        <Button
                                            id="toggle-play"
                                            data-state="play"
                                            onClick={() => helpIsActive ? handleTooltips('007') : playPauseCurrentVideo()}
                                            variant="warning"
                                            className="player-button toggle"
                                            title="Toggle Play" />
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        trigger="focus"
                                        placement={'bottom'}
                                        overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.VIDEO_INCREASE_PLAYBACK}</Tooltip>}>
                                        <Button
                                            id="accelerate-playback"
                                            onClick={() => helpIsActive ? handleTooltips('009') : handlePlaybackSpeed(0.1)()}
                                            variant="warning"
                                            className="player-button" />
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        trigger="focus" //missing tooltip video
                                        placement={'bottom'}
                                        overlay={<Tooltip style={{ display: helpIsActive ? 'none' : 'none' }} id={'helper-tooltip'}>{tooltips.VIDEO_PLAYBACK_SPEED}</Tooltip>}>
                                        <Button
                                            id="playback-rate"
                                            variant="warning"
                                            className="player-button">{mySelectedVideo.currentRate}
                                        </Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        trigger="focus"
                                        placement={'bottom'}
                                        overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.VIDEO_SNAP}</Tooltip>}>
                                        <Button
                                            id="snapshot"
                                            onClick={() => helpIsActive ? handleTooltips('012') : takeSnap()}
                                            variant="warning"
                                            className="player-button" />
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        trigger="focus"
                                        placement={'bottom'}
                                        overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.VIDEO_SUBS}</Tooltip>}>
                                        <Button
                                            id="subtitles"
                                            onClick={() => helpIsActive ? handleTooltips('011') : toggleSubtitles()}
                                            variant="warning"
                                            style={{ opacity: enableSubtitles ? 1 : 0.4 }}
                                            className="player-button"
                                            data-state="subtitles" />
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        trigger="focus"
                                        placement={'bottom'}
                                        overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.VIDEO_MUTE}</Tooltip>}>
                                        <Button
                                            onClick={() => helpIsActive ? handleTooltips('013') : toggleVolume()}
                                            id="mute"
                                            variant="warning"
                                            className="player-button"
                                            data-state="mute" />
                                    </OverlayTrigger>
                                    <input
                                        onChange={changeVolume}
                                        type="range"
                                        id="volume-control"
                                        className="volume-slider"
                                        min="0"
                                        max="1"
                                        step="0.125"
                                        value={currentVolume} />
                                    <OverlayTrigger
                                        trigger="focus"
                                        placement={'bottom'}
                                        overlay={<Tooltip style={{ display: helpIsActive ? 'inherit' : 'none' }} id={'helper-tooltip'}>{tooltips.VIDEO_FULL_SCRN}</Tooltip>}>
                                        <Button
                                            onClick={() => helpIsActive ? handleTooltips('008') : toggleFullScreen()}
                                            id="fs"
                                            variant="warning"
                                            className="player-button player-fullscreen"
                                            title="Fullscreen" />
                                    </OverlayTrigger>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ marginLeft: '5%' }}>
                        <div className="snap-container" onClick={editSnap}>
                            {snapShots.length > 0 && <FontAwesomeIcon style={{ width: '25px', height: '25px', cursor: 'pointer', marginLeft: '10px' }} color="tomato" icon="trash-alt" onClick={deleteAllSnaps} />}
                            <div className="printable" id='print-area' style={{ position: 'absolute', zIndex: '-9999' }} />
                        </div>
                    </Row>
                </Col>
            </Row>
            <SnapModal
                snapShots={snapShots}
                show={isSnapModalOpen}
                handleClose={handleClose}
                id={currentSnapId}
                saveSnapData={saveSnapData}
                printSnap={printSnap}
                deleteSnap={deleteSnap}
            />
            <FullScreenModal
                show={showFullScreenPdf}
                setPageNumber={setPageNumber}
                handleChangePage={handleChangePage}
                numPages={numPages}
                pageNumber={pageNumber}
                setControlPageNumber={setControlPageNumber}
                handleGoToPage={handleGoToPage}
                disableAutoPlay={disableAutoPlay}
                handleToggleDocFullScreen={handleToggleDocFullScreen}
                controlPageNumber={controlPageNumber}
                initialize={initialize}
                selectedBook={selectedBook}
                handleLoadSuccess={handleLoadSuccess}
            />
        </Container>
    )

}
export default Main